import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LanguageStringsComponent } from './language-strings/language-strings.component';
import { DemoComponentComponent } from './demo-component/demo-component.component';


// Route Configuration
const DevelopmentRoutes: Routes = [
    { path: 'language-strings', component: LanguageStringsComponent },
    { path: 'demo-components', component: DemoComponentComponent },
];

export const DevelopmentRouting: ModuleWithProviders = RouterModule.forChild(DevelopmentRoutes)


// WEBPACK FOOTER //
// ./src/app/shared/modules/development/development.routings.ts